/**
 * Przelewy z wyciągu Pekao (TRE-2172): import CSV, dopasowanie do nieopłaconych rat
 * i ręczne przypisanie tego, czego automat nie rozpoznał. Nic nie księguje się samo —
 * dopasowanie to propozycja, zaksięgowanie to kliknięcie w panelu.
 */

export const CollectionsBankTransactionStatus = {
  /** Automat znalazł jedną wiarygodną ratę; czeka na zaksięgowanie. */
  Proposed: "proposed",
  /** Brak pewnego dopasowania; osoba wybiera sprawę i ratę. */
  Unmatched: "unmatched",
  /** Rata oznaczona jako opłacona (faktura w Stripe zamknięta poza systemem). */
  Settled: "settled",
  /** To nie rata (opłata za zawieszenie, zwrot, przelew własny). */
  Ignored: "ignored",
} as const;

export type CollectionsBankTransactionStatus =
  (typeof CollectionsBankTransactionStatus)[keyof typeof CollectionsBankTransactionStatus];

export const COLLECTIONS_BANK_TRANSACTION_STATUS_LABELS: Record<CollectionsBankTransactionStatus, string> = {
  proposed: "Dopasowany",
  unmatched: "Do przypisania",
  settled: "Zaksięgowany",
  ignored: "Pominięty",
};

/** A rata the transfer may be paying for, with why the matcher thinks so. */
export interface CollectionsBankCandidate {
  orderId: string;
  productId: string;
  productName: string | null;
  clientEmail: string;
  clientName: string | null;
  orderNumber: number | null;
  paymentCycle: number | null;
  /** grosze */
  amount: number;
  source: "manual" | "card";
  /** 0–100; ≥ 65 with a clear lead becomes the proposal. */
  score: number;
  reasons: string[];
}

export interface CollectionsBankImport {
  id: string;
  createdAt: string;
  importedBy: string | null;
  fileName: string;
  rowsTotal: number;
  rowsCredits: number;
  rowsNew: number;
  rowsDuplicate: number;
}

export interface CollectionsBankTransaction {
  id: string;
  importId: string;
  createdAt: string;
  /** YYYY-MM-DD, data księgowania */
  bookedAt: string;
  /** grosze, always positive — debits are not imported */
  amount: number;
  currency: string;
  counterparty: string | null;
  account: string | null;
  title: string;
  /** The CSV row as imported, keyed by header. */
  raw: Record<string, string>;
  /** Hash of date + amount + account + title — the same line imported twice is one transfer. */
  fingerprint: string;
  status: CollectionsBankTransactionStatus;
  proposedOrderId: string | null;
  candidates: CollectionsBankCandidate[];
  settledOrderId: string | null;
  settledAt: string | null;
  settledBy: string | null;
  ignoredReason: string | null;
}
